module.exports = __webpack_public_path__ + "img/3w_tassei.280d3e75.png";